import { Chart } from "../types/charts";
import httpClient from "./httpClient";

export const charts = {
	fetch: async (): Promise<Chart[] | undefined> => {
		const response = await httpClient.get(`/dailydata/reports`);
		return response.data as Chart[];
	}
};
